import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * tailwind-merge solo conoce la escala por defecto de Tailwind. Sin esto toma `text-fs-12`
 * por un color (y borra el tamaño o el color según cuál venga después), y no reconoce
 * `shadow-frost-*` ni `rounded-frost-*` como sombra o radio, así que un override por
 * `className` no reemplaza al del primitivo. Los nombres salen del `@theme` de
 * `src/styles/_tailwind.css`: si se agrega un token ahí, sumarlo acá.
 */
const isFrostFontSize = (value: string) => /^fs-\d+(?:-5)?$/.test(value);

const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      text: [isFrostFontSize],
      shadow: [
        'frost-xs',
        'frost-sm',
        'frost-md',
        'frost-lg',
        'frost-glow',
        'frost-glow-lg',
        'frost-glow-coral',
        'frost-glow-coral-lg',
        'frost-glow-warning',
        'frost-glow-warning-lg',
        'frost-inset'
      ],
      radius: [
        'frost-sm',
        'frost-chip',
        'frost-item',
        'frost-button',
        'frost-input',
        'frost-card',
        'frost-shell'
      ],
      blur: ['glass', 'frost'],
      ease: ['frost', 'frost-out', 'frost-std']
    },
    classGroups: {
      duration: [{ duration: ['fast', 'base', 'slow'] }],
      z: [{ z: ['rail', 'sticky', 'takeover', 'scrim', 'sheet', 'modal', 'toast', 'popover', 'max'] }]
    }
  }
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
